import { Button, Card } from 'antd'
import { useState } from 'react'
import { SettingsEditor } from "./SettingsEditor.tsx"
import { EditOutlined } from "@ant-design/icons"

export const SettingsEditorPopup = () => {
    const [show, setShow] = useState(false)

    return <div>
        <Button type='primary' icon={<EditOutlined />} onClick={() => setShow((prev) => !prev)}></Button>
        <Card
            style={{
                width: '600px',
                display: show ? 'block' : 'none',
                position: 'absolute',
                top: '30px',
                zIndex: 100,
            }}
        >
            <SettingsEditor onSubmit={() => setShow(() => false)} />
        </Card>
    </div>
}
